module.exports = __webpack_public_path__ + "83a4ed321bbb04e1b3ae896d893dc23a.pdf";